import { render, staticRenderFns } from "./AudioIcon.vue?vue&type=template&id=2c30cb2d&scoped=true&"
import script from "./AudioIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AudioIcon.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AudioIcon.vue?vue&type=style&index=0&id=2c30cb2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30cb2d",
  null
  
)

export default component.exports